import api, { fetchAllPages } from "./client";

export const barberosApi = {
  getAll: () => fetchAllPages("/barberos/"),
  getActive: () => fetchAllPages("/barberos/", { activo: true }),
  create: (data) => api.post("/barberos/", data),
  update: (id, data) => api.patch(`/barberos/${id}/`, data),
};



